import API from '../utils/api'

const searchApiBaseUrl = '/api/search';
const contentUrl = searchApiBaseUrl + '/findinsights/';


export function findInsights(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}